(() => {
  const photoStates = new WeakMap();
  function initPhotos(scope) {
    scope.querySelectorAll('[data-hg-photo]').forEach(input => {
      if (input.dataset.hgBound) return;
      input.dataset.hgBound = 'true';
      const figure = document.createElement('figure');
      figure.className = 'hg-photo-preview';
      figure.hidden = true;
      const image = document.createElement('img');
      image.width = image.height = 88;
      image.alt = 'Your selected photo';
      const caption = document.createElement('figcaption');
      const name = document.createElement('strong');
      const note = document.createElement('p');
      note.textContent = 'Selected photo · not a finished design preview';
      const actions = document.createElement('div');
      actions.className = 'hg-photo-preview-actions';
      const change = document.createElement('button');
      change.type = 'button';
      change.textContent = 'Change photo';
      change.setAttribute('aria-label', 'Change ' + (document.querySelector('label[for="' + input.id + '"]')?.childNodes[0]?.textContent.trim() || 'photo'));
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = 'Remove';
      remove.setAttribute('aria-label', 'Remove ' + (document.querySelector('label[for="' + input.id + '"]')?.childNodes[0]?.textContent.trim() || 'photo'));
      actions.append(change, remove);
      caption.append(name, note, actions);
      figure.append(image, caption);
      input.after(figure);
      let status = input.closest('.hg-upload')?.querySelector('[data-hg-file-status]');
      if (!status) {
        status = document.createElement('p');
        status.className = 'hg-photo-status';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        figure.after(status);
      }
      const clearPreview = () => {
        const previous = photoStates.get(input);
        if (previous) URL.revokeObjectURL(previous);
        photoStates.delete(input);
        image.removeAttribute('src');
        figure.hidden = true;
      };
      const update = () => {
        clearPreview();
        const file = input.files?.[0];
        const typeOK = !file || ['image/jpeg', 'image/png'].includes(file.type) || (!file.type && /\.(jpe?g|png)$/i.test(file.name));
        const error = file && file.size > 10 * 1024 * 1024 ? 'Please choose a photo no larger than 10 MB.' : !typeOK ? 'Please choose a JPG or PNG photo.' : '';
        input.setCustomValidity(error);
        status.textContent = error || (file ? 'Photo selected: ' + file.name : '');
        input.dispatchEvent(new Event('hg:photo-state', { bubbles: true }));
        if (error) { input.reportValidity(); return; }
        if (!file) return;
        const url = URL.createObjectURL(file);
        photoStates.set(input, url);
        name.textContent = file.name;
        image.onload = () => { if (photoStates.get(input) === url) figure.hidden = false; };
        image.onerror = () => {
          if (photoStates.get(input) !== url) return;
          clearPreview();
          input.setCustomValidity('This photo could not be opened. Please choose another JPG or PNG.');
          status.textContent = 'This photo could not be opened. Please choose another JPG or PNG.';
          input.dispatchEvent(new Event('hg:photo-state', { bubbles: true }));
        };
        image.src = url;
      };
      input.addEventListener('change', update);
      change.addEventListener('click', () => input.click());
      remove.addEventListener('click', () => {
        input.value = '';
        update();
        status.textContent = 'Photo removed. Choose another photo.';
        input.focus();
      });
      input.form?.addEventListener('reset', () => {
        clearPreview();
        input.setCustomValidity('');
        status.textContent = '';
      });
    });
  }
  function initBuilders(scope) {
    scope.querySelectorAll('[data-hg-builder]').forEach(builder => {
      if (builder.dataset.hgBound) return;
      builder.dataset.hgBound = 'true';
      const choices = [...builder.querySelectorAll('[data-hg-mix-choice]')];
      const presets = [...builder.querySelectorAll('[data-hg-preset]')];
      const checklist = builder.querySelector('.hg-mix-checklist');
      const show = builder.querySelector('[data-hg-show-mix]');
      const key = 'hugfetti-party-mix-v1';
      try {
        const saved = JSON.parse(sessionStorage.getItem(key));
        if (Array.isArray(saved)) choices.forEach(choice => { choice.checked = saved.includes(choice.value); });
      } catch (_) { /* Selection works when session storage is unavailable. */ }
      const draw = () => {
        const selected = choices.filter(choice => choice.checked).map(choice => choice.value);
        choices.forEach(choice => choice.closest('[data-hg-mix-item]').classList.toggle('is-selected', choice.checked));
        presets.forEach(button => {
          const values = button.dataset.hgPreset.split(',');
          button.setAttribute('aria-pressed', String(values.length === selected.length && values.every(value => selected.includes(value))));
        });
        builder.querySelector('[data-hg-mix-count]').textContent = selected.length ? selected.length + ' product' + (selected.length === 1 ? '' : 's') + ' selected' : 'Choose at least one product for your mix.';
        show.disabled = !selected.length;
        builder.querySelectorAll('[data-hg-mix-step]').forEach(step => { step.hidden = !selected.includes(step.dataset.hgMixStep); });
        if (!selected.length) {
          checklist.hidden = true;
          show.setAttribute('aria-expanded', 'false');
        }
        try { sessionStorage.setItem(key, JSON.stringify(selected)); } catch (_) { /* No photo data is stored. */ }
      };
      choices.forEach(choice => {
        choice.closest('label').hidden = false;
        choice.addEventListener('change', draw);
      });
      presets.forEach(button => button.addEventListener('click', () => {
        const values = button.dataset.hgPreset.split(',');
        choices.forEach(choice => { choice.checked = values.includes(choice.value); });
        draw();
      }));
      builder.querySelector('[data-hg-presets]').hidden = false;
      builder.querySelector('[data-hg-mix-actions]').hidden = false;
      show.addEventListener('click', () => {
        checklist.hidden = false;
        show.setAttribute('aria-expanded', 'true');
        builder.querySelector('[data-hg-mix-heading]').focus({ preventScroll: true });
        checklist.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
      });
      draw();
    });
  }
  function initMenus(scope) {
    scope.querySelectorAll('.hg-nav .hg-menu').forEach(menu => {
      if (menu.dataset.hgBound) return;
      menu.dataset.hgBound = 'true';
      const summary = menu.querySelector('summary');
      const desktop = window.matchMedia('(min-width: 951px) and (hover: hover)');
      let timer;
      menu.addEventListener('pointerenter', () => {
        if (!desktop.matches) return;
        clearTimeout(timer);
        timer = setTimeout(() => { menu.open = true; }, 120);
      });
      menu.addEventListener('pointerleave', () => {
        clearTimeout(timer);
        if (desktop.matches && !menu.contains(document.activeElement)) {
          timer = setTimeout(() => { menu.open = false; }, 220);
        }
      });
      menu.addEventListener('focusout', event => {
        if (!menu.contains(event.relatedTarget) && !menu.matches(':hover')) menu.open = false;
      });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          clearTimeout(timer);
          menu.open = false;
          summary.focus();
        } else if (event.key === 'ArrowDown' && event.target === summary) {
          event.preventDefault();
          menu.open = true;
          menu.querySelector('a')?.focus();
        }
      });
      document.addEventListener('pointerdown', event => {
        if (!menu.contains(event.target)) { clearTimeout(timer); menu.open = false; }
      });
    });
  }
  function initCustomizers(scope) {
    scope.querySelectorAll('[data-hg-customizer]').forEach(form => {
      if (form.dataset.hgBound) return;
      form.dataset.hgBound = 'true';
      const review = form.querySelector('[data-hg-review]');
      const update = () => {
        const option = form.querySelector('input[name="id"]:checked, input[type="hidden"][name="id"]');
        const photos = [...form.querySelectorAll('[data-hg-photo]')];
        const selected = photos.filter(input => input.files?.length && input.validity.valid);
        const hasError = photos.some(input => input.files?.length && !input.validity.valid);
        const requiredPhoto = photos.find(input => input.required);
        const ready = requiredPhoto?.files?.length && requiredPhoto.validity.valid && !hasError;
        form.querySelector('[data-hg-options-status]').textContent = option ? 'Selected' : 'Choose an option';
        const photoStatus = form.querySelector('[data-hg-photo-step-status]');
        photoStatus.textContent = hasError ? 'Check your photo' : ready ? 'Photo added' : 'Photo required';
        photoStatus.classList.toggle('is-ready', Boolean(ready));
        form.querySelector('[data-hg-review-option]').textContent = option?.dataset.hgOption === 'Default Title' ? 'One personalized item' : option?.dataset.hgOption || 'Choose an option';
        form.querySelector('[data-hg-review-photos]').textContent = hasError ? 'Check the photo error above' : selected.length ? selected.length + ' photo' + (selected.length === 1 ? '' : 's') + ' selected' : 'Add your required photo';
        [['Name', 'name'], ['Age', 'age'], ['Sash text', 'sash']].forEach(([property, target]) => {
          const output = form.querySelector('[data-hg-review-' + target + ']');
          if (output) output.textContent = form.querySelector('[name="properties[' + property + ']"]')?.value.trim() || (target === 'sash' ? 'As shown in the example' : 'Not added');
        });
        const submit = form.querySelector('button[type="submit"]');
        if (option?.dataset.hgAvailable) submit.disabled = option.dataset.hgAvailable !== 'true';
      };
      form.addEventListener('input', update);
      form.addEventListener('change', update);
      form.addEventListener('hg:photo-state', update);
      form.addEventListener('reset', () => setTimeout(update, 0));
      review.hidden = false;
      update();
    });
  }
  function initProductTabs(scope) {
    scope.querySelectorAll('[data-hg-product-tabs]').forEach(group => {
      if (group.dataset.hgBound) return;
      group.dataset.hgBound = 'true';
      const list = group.querySelector('[role="tablist"]');
      const tabs = [...list.querySelectorAll('[role="tab"]')];
      const panels = [...group.querySelectorAll('[data-hg-panel]')];
      const desktop = window.matchMedia('(min-width: 701px)');
      let active = 0;
      const draw = () => {
        list.hidden = !desktop.matches;
        group.classList.toggle('hg-tabs-active', desktop.matches);
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === active));
          tab.tabIndex = i === active ? 0 : -1;
          const panel = panels[i];
          panel.hidden = desktop.matches && i !== active;
          if (desktop.matches) {
            panel.open = true;
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', tab.id);
            panel.tabIndex = 0;
          } else {
            panel.removeAttribute('role');
            panel.removeAttribute('aria-labelledby');
            panel.removeAttribute('tabindex');
            panel.open = i === active;
          }
        });
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => { active = i; draw(); });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          active = next;
          draw();
          tabs[next].focus();
        });
      });
      panels.forEach((panel, i) => panel.addEventListener('toggle', () => {
        if (!desktop.matches && panel.open) active = i;
      }));
      desktop.addEventListener('change', draw);
      draw();
    });
  }
  function init(scope = document) {
    initPhotos(scope);
    initBuilders(scope);
    initMenus(scope);
    initCustomizers(scope);
    initProductTabs(scope);
    scope.querySelectorAll('[data-hg-gallery-src]').forEach(button => {
      if (button.dataset.hgBound) return;
      button.dataset.hgBound = 'true';
      button.addEventListener('click', () => {
        const image = document.querySelector('[data-hg-main-image]');
        if (image) {
          image.src = button.dataset.hgGallerySrc;
          image.alt = button.getAttribute('aria-label');
          document.querySelectorAll('[data-hg-gallery-src]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        }
      });
    });
    scope.querySelectorAll('.hg-variants input').forEach(input => {
      if (input.dataset.hgBound) return;
      input.dataset.hgBound = 'true';
      input.addEventListener('change', () => {
        const price = input.closest('.hg-product-info')?.querySelector('[data-hg-price]');
        if (price) price.textContent = input.dataset.price;
      });
    });
    scope.querySelectorAll('[data-hg-sort]').forEach(sort => {
      if (sort.dataset.hgBound) return;
      sort.dataset.hgBound = 'true';
      sort.addEventListener('change', event => {
        const grid = document.querySelector('[data-hg-grid]');
        if (!grid) return;
        const cards = [...grid.querySelectorAll('.hg-product-card')];
        cards.forEach((card, index) => { if (!card.dataset.originalOrder) card.dataset.originalOrder = String(index); });
        cards.sort((a, b) => {
          switch (event.target.value) {
            case 'price-low': return +a.dataset.price - +b.dataset.price;
            case 'price-high': return +b.dataset.price - +a.dataset.price;
            case 'name': return a.dataset.name.localeCompare(b.dataset.name);
            default: return +a.dataset.originalOrder - +b.dataset.originalOrder;
          }
        }).forEach(card => grid.appendChild(card));
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('pagehide', () => {
    document.querySelectorAll('[data-hg-photo]').forEach(input => {
      const url = photoStates.get(input);
      if (url) URL.revokeObjectURL(url);
    });
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) document.querySelectorAll('[data-hg-photo]').forEach(input => input.dispatchEvent(new Event('change')));
  });
})();
